import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { ContentContainer } from "@faire/retailer-visitor-shared/components/GiftGuide/common";
import { getTotalBrandCount } from "@faire/retailer-visitor-shared/lib/getMarketingCount";
import { popSignUp, SignUpElement, SignUpType } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { DEPRECATED_backwardsCompatibleValues, useStrictLocalization } from "@faire/web--source/common/localization/localize";
import { Button } from "@faire/web--source/slate/Button";
import { Column, Flex, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { observer } from "mobx-react";
import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
var SignUpBannerBase = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var history = useHistory();
    return /*#__PURE__*/ _jsx(Background, {
        children: /*#__PURE__*/ _jsxs(StyledContentContainer, {
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    align: "center",
                    variant: {
                        mobileAndAbove: "displaySSerifRegular",
                        tabletAndAbove: "displayMSerifRegular"
                    },
                    color: Core.text.inverse,
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "KH0nRl",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Ready to start ordering wholesale online?"
                            }
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "5x"
                }),
                /*#__PURE__*/ _jsx(ResponsiveContainer, {
                    children: perks(strictLocalize).map(function(perk, index) {
                        return /*#__PURE__*/ _jsxs(React.Fragment, {
                            children: [
                                index === 0 ? null : /*#__PURE__*/ _jsx(Spacer, {
                                    size: "3x"
                                }),
                                /*#__PURE__*/ _jsxs(PerkContainer, {
                                    children: [
                                        /*#__PURE__*/ _jsxs(Typography, {
                                            color: Core.text.inverse,
                                            children: [
                                                "0",
                                                index + 1
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Spacer, {
                                            width: "3x"
                                        }),
                                        /*#__PURE__*/ _jsxs(Column, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Typography, {
                                                    color: Core.text.inverse,
                                                    children: perk.head
                                                }),
                                                /*#__PURE__*/ _jsx(Spacer, {
                                                    height: "1x"
                                                }),
                                                /*#__PURE__*/ _jsx(Typography, {
                                                    color: Core.text.inverse,
                                                    children: perk.body
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, index);
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "5x"
                }),
                /*#__PURE__*/ _jsx(StyledButton, {
                    variant: "secondary",
                    onClick: function() {
                        return popSignUp(history, SignUpType.GENERIC, function() {
                            return null;
                        }, {
                            element: SignUpElement.BELOW_FOLD,
                            sourceId: "wholesale_gifts_sign_up_cta"
                        });
                    },
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "3BK5HJ",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Sign up to shop"
                            }
                        ]
                    })
                })
            ]
        })
    });
};
export var SignUpBanner = observer(SignUpBannerBase);
var Background = styled.div.withConfig({
    componentId: "sc-9dd82ffc-0"
})([
    "background-color:",
    ";"
], Decorative.shade.yellow);
var StyledContentContainer = styled(ContentContainer).withConfig({
    componentId: "sc-9dd82ffc-1"
})([
    "align-items:center;padding:",
    ";",
    "{max-width:450px;}",
    "{padding:",
    ";}"
], getSpacing("6x", "3x"), responsiveMediaQueries.tablet, responsiveMediaQueries.tabletAndAbove, getSpacing("10x", 0));
var ResponsiveContainer = styled(Flex).attrs({
    direction: {
        mobileAndAbove: "column",
        desktopAndAbove: "row"
    }
}).withConfig({
    componentId: "sc-9dd82ffc-2"
})([
    ""
]);
var PerkContainer = styled(Row).withConfig({
    componentId: "sc-9dd82ffc-3"
})([
    "",
    "{max-width:300px;}"
], responsiveMediaQueries.tabletAndAbove);
var StyledButton = styled(Button).withConfig({
    componentId: "sc-9dd82ffc-4"
})([
    "width:fit-content;min-width:200px;"
]);
var perks = function(strictLocalize) {
    return [
        {
            head: strictLocalize({
                id: "SmcFQp",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Find unique products"
                    }
                ]
            }),
            body: strictLocalize({
                id: "4SJvUF",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Shop over "
                    },
                    {
                        type: 1,
                        value: "brandCount"
                    },
                    {
                        type: 0,
                        value: " independent brands, all in one place."
                    }
                ]
            }, DEPRECATED_backwardsCompatibleValues({
                brandCount: getTotalBrandCount()
            }))
        },
        {
            head: strictLocalize({
                id: "Pl9uAr",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Buy now, pay later"
                    }
                ]
            }),
            body: strictLocalize({
                id: "oz24L9",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Pay up to 60 days later\u2014interest-free."
                    }
                ]
            })
        },
        {
            head: strictLocalize({
                id: "EMr6U3",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Buy with confidence"
                    }
                ]
            }),
            body: strictLocalize({
                id: "XxbyIK",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Get free returns on your opening order with any brand."
                    }
                ]
            })
        }
    ];
};
